import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Clears an uncontrolled text input in a way React (and libraries listening to
 * the synthetic change event, e.g. cmdk or Base UI's combobox) picks up.
 *
 * Setting `el.value = ""` alone is invisible to React's synthetic event system,
 * so we go through the native value setter and dispatch a bubbling `input`
 * event, which React maps to `onChange`.
 */
export function clearInputElement(el: HTMLInputElement | null | undefined) {
  if (!el) return;
  const nativeSetter = Object.getOwnPropertyDescriptor(
    HTMLInputElement.prototype,
    "value",
  )?.set;
  if (nativeSetter) {
    nativeSetter.call(el, "");
  } else {
    el.value = "";
  }
  el.dispatchEvent(new Event("input", { bubbles: true }));
}
